import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  menu: Yup.object().shape({
    nombre: Yup.string().required('campo obligatorio'),
    url: Yup.string().required('campo obligatorio'),
    esBoton: Yup.boolean().required('campo obligatorio'),
    onClick: Yup.string().when('esBoton', {
      is: true,
      then: Yup.string().required('Campo obligatorio')
    })
  }),

  submenu: Yup.array()
    .of(
      Yup.object().shape({
        nombre: Yup.string().required('campo obligatorio'),
        url: Yup.string().nullable(),
        archivo: Yup.mixed().nullable(),
        esBoton: Yup.boolean().required('campo obligatorio'),
        onClick: Yup.string().when('esBoton', {
          is: true,
          then: Yup.string().required('Campo obligatorio')
        })
      }).test(
        'url-o-archivo',
        'Debe ingresar una URL o subir una imagen/archivo',
        function (value) {
          const hasUrl = !!value?.url?.trim();
          const hasArchivo = !!value?.archivo?.url;

          if (hasUrl || hasArchivo) return true;

          return this.createError({
            path: `${this.path}.url`,
            message: 'Debe ingresar una URL o subir una imagen/archivo',
          });
        }
      )
    )
    .when('menu.url', {
      is: '#',
      then: (schema) => schema.min(1, 'Se requiere un item de submenú')
    })
});